import Fuse from 'fuse.js';
import axios from 'axios';
import Help from "@/Help";
const webapiUrl = window.webapiUrl;
export class AutoCompleteResult {
    constructor(name, address, organisation, latitude, longitude, pinClass, pinTitle, isSps) {
        this.name = name;
        this.address = address;
        this.organisation = organisation;
        this.latitude = latitude;
        this.longitude = longitude;
        this.pinClass = pinClass;
        this.pinTitle = pinTitle;
        this.isSps = isSps;
    }
}
function mbToAutoCompleteResult(mb) {
    return new AutoCompleteResult(mb.text, removeUk(mb.place_name), "Location Result", //<i class="fad fa-thumbtack"></i> || <i class="fad fa-map-pin"></i>
    mb.center[1], mb.center[0], //<i class="fa-duotone fa-solid fa-location-dot"></i>
    "fad fa-thumbtack", //"fad fa-map-marker-alt",//geoCode //<i class="fa-duotone fa-solid fa-map-pin"></i>   <font-awesome-icon :icon="['fad', 'map-pin']" />
    "Point of Interest / Location Result", //<i class="fa-solid fa-map-pin"></i> <font-awesome-icon :icon="['fas', 'map-pin']" />
    false //old <i class="fad fa-map-marker-alt"></i> https://fontawesome.com/v5/icons/map-marker-alt?f=classic&s=duotone
    ); //new <i class="fad fa-thumbtack"></i>  or <i class="fad fa-map-marked"></i>
}
export function getSpsCarParks() { return axios.get(webapiUrl).then(response => { return response.data; }); }
export function searchMbResultsAndSpsSites(mbApiResults, sitesFiltered, searchTerm) {
    const mbResults = mbApiResults.map(mb => mbToAutoCompleteResult(mb));
    let mbResultsAndSpsSites = [...sitesFiltered, ...mbResults];
    let fuseResults = new Fuse(mbResultsAndSpsSites, fuseOptions).search(searchTerm);
    let fuseResultsRelevant = (fuseResults.length > maxResults) ? fuseResults.slice(0, maxResults) : fuseResults;
    return fuseResultsRelevant.map(s => toAcResult(s.item));
}
function toAcResult(s) {
    if (s.isSps) {
        var x = getPinInfo(s); //TODO:MAP better to do this 1x when get api results from sps, and mod our ISpsApiResult to inc these two values... then never have to do again?
        return { ...s, ...x };
    }
    else
        return s;
}
const ukStringToMatch = ", United Kingdom";
function removeUk(mbAddress) {
    let respVal = mbAddress;
    let endsWithUk = mbAddress.trimEnd().endsWith(ukStringToMatch);
    if (endsWithUk) {
        var indexOfLastUk = mbAddress.lastIndexOf(ukStringToMatch);
        respVal = mbAddress.substring(0, indexOfLastUk);
    }
    return respVal;
}
export class FilterData {
    constructor(name, faIcon, description, selected = false) {
        this.name = name;
        this.faIcon = faIcon;
        this.description = description;
        this.selected = selected;
        if (Help.isNullOrEmpty(description))
            this.description = this.name;
    }
}
export function getPinInfo(data) {
    let pinClass = "";
    let pinTitle = "";
    if (data.hasPmf) {
        pinClass = "fas bcs_pmf_pin";
        pinTitle = "Awarded: Park Mark Freight";
    }
    else if (data.hasPmp && !data.hasPa && data.hasPm) {
        pinClass = "fas bcs_pmp_pin";
        pinTitle = "Awarded: Park Mark, Park Mark Plus";
    }
    else if (data.hasPmp && data.hasPa && data.hasPm) {
        pinClass = "fas bcs_pmp_pa_pin";
        pinTitle = "Awarded: Park Mark, Park Mark Plus, Park Access";
    }
    else if (!data.hasPmp && data.hasPa && data.hasPm) {
        pinClass = "fas bcs_pm_pa_pin";
        pinTitle = "Awarded: Park Mark, Park Access";
    }
    else if (!data.hasPm && data.hasPa) {
        pinClass = "fas bcs_pa_pin";
        pinTitle = "Awarded: Park Access";
    }
    else if (data.hasAmGo) {
        pinClass = "fas bcs_am-go_pin";
        pinTitle = "Awarded: Park Mark, AM-GO";
    }
    else {
        pinClass = "fas bcs_pm_pin";
        pinTitle = "Awarded: Park Mark";
    }
    return { pinClass, pinTitle };
}
export function getFilters() {
    return [
        new FilterData("Park Mark", "bcs_pm", "Park Mark Accreditation"),
        new FilterData("Park Mark Plus", "bcs_pmp", "Park Mark Plus Accreditation"),
        new FilterData("Park Access", "bcs_pa", "Park Access Accreditation"),
        new FilterData("Park Mark Freight", "bcs_pmf", "Park Mark Freight Accreditation"),
        new FilterData("AM-GO", "bcs_am-go", "AM-GO Accreditation"),
        new FilterData("ECP", "fa-charging-station", "Sites with a number of Electronic Charging Points"),
        new FilterData("Open 24 Hours", "fa-alarm-clock", "Sites Open 24 Hours (today)"),
        new FilterData("Meet and Greet", "fa-hands-helping", "Sites tagged as Meet and Greet"),
        new FilterData("Accessible Spaces", "fa-wheelchair", "Sites with a number of Accessible Spaces"),
        new FilterData("Parent and Child", "fa-baby-carriage", "Sites with a number of Parent and Child Spaces"),
        //
        new FilterData("Cycle", "fa-bicycle", "Sites listed as accepting Bicycles"),
        new FilterData("Motorcycle", "fa-motorcycle", "Sites listed as accepting Motorcycles"),
        new FilterData("Lorry", "fa-truck", "Sites listed as accepting Lorries"),
        new FilterData("Coach", "fa-shuttle-van", "Sites listed as accepting Coaches"),
        //
        new FilterData("Airport", "fa-plane-departure", "Sites tagged as related to an Airport"),
        new FilterData("Station", "fa-subway", "Sites tagged as related to a Train Station"),
        new FilterData("Town Centre", "fa-city", "Sites tagged as related to a City/Town Centre")
    ];
}
const maxResults = 10;
const fuseOptions = {
    includeScore: true,
    keys: ["name", "address", "organisation"]
};
